import(/* webpackMode: "eager" */ "/app/src/app/photos/page.tsx")